function Ctrl($scope, utilsService, $sce) {

  $scope.richJson = function() {
    if (!$scope.venue || !$scope.venue.id) return '';

    const {
      venue
    } = $scope;

    const address = (venue.location ? venue.location.address : {}) || {};

    const json = {
      '@context': 'http://schema.org',
      '@type': 'NightClub',
      name: venue.name,
      url: utilsService.createUrl(`/v/${venue.seoPathname}`),
      image: venue.primaryImage ? venue.primaryImage.filename : null,
      address: `${address.address}, ${address.city}, ${address.state} ${address.zip}`
    };

    return $sce.trustAsHtml(JSON.stringify(json, null, 2));
  };
}

Ctrl.$inject = [
  '$scope',
  'utilsService',
  '$sce'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/richVenueCard/controller.js